export const initTimeTable = [
  {
    routeId: '8',
    routePrefix: '8',
    busCode: 'A',
    timeStop: 5,
    numBus: 1,
    maxBus: 1,
    stopList: [
      {
        direction: '1',
        stops: ['A1', 'A2', 'A3', 'A4', 'A5'],
      },
      {
        direction: '2',
        stops: ['A6', 'A7', 'A8', 'A9', 'A10'],
      },
    ],
    timetable: [],
    busArr: ['A80001'],
  },
  {
    routeId: '11',
    routePrefix: '11',
    busCode: 'B',
    timeStop: 5,
    numBus: 1,
    maxBus: 1,
    stopList: [
      {
        direction: '1',
        stops: ['B1', 'B2', 'B3', 'B4', 'B5'],
      },
      {
        direction: '2',
        stops: ['B6', 'B7', 'B8', 'B9', 'B10'],
      },
    ],
    timetable: [],
    busArr: ['B11002'],
  },
];

export const FIXED_TIMETABLE = [
  {
    routeId: '8',
    numBus: 1,
    stopList: [
      {
        direction: '1',
        stops: ['A1', 'A2', 'A3', 'A4', 'A5'],
      },
      {
        direction: '2',
        stops: ['A6', 'A7', 'A8', 'A9', 'A10'],
      },
    ],
    timetable: [
      {
        direction: '1',
        trips: [
          {
            blockId: 'A80001',
            vehicleId: 'AV01',
            tripId: 'T8100001',
            stops: [
              {
                stopId: 'A1',
                stopSequence: 1,
                schArrTime: '09:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'A2',
                stopSequence: 2,
                schArrTime: '09:02:29',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'A3',
                stopSequence: 3,
                schArrTime: '09:05:54',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'A4',
                stopSequence: 4,
                schArrTime: '09:08:59',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'A5',
                stopSequence: 5,
                schArrTime: '09:11:34',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
            ],
            direction: '1',
            isTimeFiltered: false,
          },
          {
            blockId: 'A80001',
            vehicleId: 'AV01',
            tripId: 'T8100002',
            stops: [
              {
                stopId: 'A1',
                stopSequence: 1,
                schArrTime: '10:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'A2',
                stopSequence: 2,
                schArrTime: '10:02:29',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'A3',
                stopSequence: 3,
                schArrTime: '10:05:54',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'A4',
                stopSequence: 4,
                schArrTime: '10:08:59',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'A5',
                stopSequence: 5,
                schArrTime: '10:11:34',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
            ],
            direction: '1',
            isTimeFiltered: false,
          },
          {
            blockId: 'A80001',
            vehicleId: 'AV01',
            tripId: 'T8100003',
            stops: [
              {
                stopId: 'A1',
                stopSequence: 1,
                schArrTime: '11:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'A2',
                stopSequence: 2,
                schArrTime: '11:02:29',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'A3',
                stopSequence: 3,
                schArrTime: '11:05:54',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'A4',
                stopSequence: 4,
                schArrTime: '11:08:59',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'A5',
                stopSequence: 5,
                schArrTime: '11:11:34',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
            ],
            direction: '1',
            isTimeFiltered: false,
          },
          {
            blockId: 'A80001',
            vehicleId: 'AV01',
            tripId: 'T8100004',
            stops: [
              {
                stopId: 'A1',
                stopSequence: 1,
                schArrTime: '13:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'A2',
                stopSequence: 2,
                schArrTime: '13:02:29',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'A3',
                stopSequence: 3,
                schArrTime: '13:05:54',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'A4',
                stopSequence: 4,
                schArrTime: '13:08:59',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'A5',
                stopSequence: 5,
                schArrTime: '13:11:34',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
            ],
            direction: '1',
            isTimeFiltered: false,
          },
          {
            blockId: 'A80001',
            vehicleId: 'AV01',
            tripId: 'T8100005',
            stops: [
              {
                stopId: 'A1',
                stopSequence: 1,
                schArrTime: '14:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'A2',
                stopSequence: 2,
                schArrTime: '14:02:29',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'A3',
                stopSequence: 3,
                schArrTime: '14:05:54',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'A4',
                stopSequence: 4,
                schArrTime: '14:08:59',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'A5',
                stopSequence: 5,
                schArrTime: '14:11:34',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
            ],
            direction: '1',
            isTimeFiltered: false,
          },
          {
            blockId: 'A80001',
            vehicleId: 'AV01',
            tripId: 'T8100006',
            stops: [
              {
                stopId: 'A1',
                stopSequence: 1,
                schArrTime: '15:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'A2',
                stopSequence: 2,
                schArrTime: '15:02:29',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'A3',
                stopSequence: 3,
                schArrTime: '15:05:54',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'A4',
                stopSequence: 4,
                schArrTime: '15:08:59',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'A5',
                stopSequence: 5,
                schArrTime: '15:11:34',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
            ],
            direction: '1',
            isTimeFiltered: false,
          },
          {
            blockId: 'A80001',
            vehicleId: 'AV01',
            tripId: 'T81000047',
            stops: [
              {
                stopId: 'A1',
                stopSequence: 1,
                schArrTime: '16:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,

                planHeadway: '16min',
              },
              {
                stopId: 'A2',
                stopSequence: 2,
                schArrTime: '16:02:29',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,

                planHeadway: '16min',
              },
              {
                stopId: 'A3',
                stopSequence: 3,
                schArrTime: '16:05:54',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,

                planHeadway: '16min',
              },
              {
                stopId: 'A4',
                stopSequence: 4,
                schArrTime: '16:08:59',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,

                planHeadway: '16min',
              },
              {
                stopId: 'A5',
                stopSequence: 5,
                schArrTime: '16:11:34',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,

                planHeadway: '16min',
              },
            ],
            direction: '1',
            isTimeFiltered: false,
          },
          {
            blockId: 'A80001',
            vehicleId: 'AV01',
            tripId: 'T8100008',
            stops: [
              {
                stopId: 'A1',
                stopSequence: 1,
                schArrTime: '17:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,

                planHeadway: '17min',
              },
              {
                stopId: 'A2',
                stopSequence: 2,
                schArrTime: '17:02:29',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,

                planHeadway: '17min',
              },
              {
                stopId: 'A3',
                stopSequence: 3,
                schArrTime: '17:05:54',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,

                planHeadway: '17min',
              },
              {
                stopId: 'A4',
                stopSequence: 4,
                schArrTime: '17:08:59',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,

                planHeadway: '17min',
              },
              {
                stopId: 'A5',
                stopSequence: 5,
                schArrTime: '17:11:34',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,

                planHeadway: '17min',
              },
            ],
            direction: '1',
            isTimeFiltered: false,
          },
        ],
      },
      {
        direction: '2',
        trips: [
          {
            blockId: 'A80001',
            vehicleId: 'AV01',
            tripId: 'T8200001',
            stops: [
              {
                stopId: 'A6',
                stopSequence: 1,
                schArrTime: '09:20:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A7',
                stopSequence: 2,
                schArrTime: '09:22:25',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A8',
                stopSequence: 3,
                schArrTime: '09:25:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A9',
                stopSequence: 4,
                schArrTime: '09:28:43',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A10',
                stopSequence: 5,
                schArrTime: '09:30:56',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
            ],
            direction: '2',
          },
          {
            blockId: 'A80001',
            vehicleId: 'AV01',
            tripId: 'T8200002',
            stops: [
              {
                stopId: 'A6',
                stopSequence: 1,
                schArrTime: '10:20:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A7',
                stopSequence: 2,
                schArrTime: '10:22:25',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A8',
                stopSequence: 3,
                schArrTime: '10:25:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A9',
                stopSequence: 4,
                schArrTime: '10:28:43',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A10',
                stopSequence: 5,
                schArrTime: '10:30:56',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
            ],
            direction: '2',
          },
          {
            blockId: 'A80001',
            vehicleId: 'AV01',
            tripId: 'T8200003',
            stops: [
              {
                stopId: 'A6',
                stopSequence: 1,
                schArrTime: '11:20:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A7',
                stopSequence: 2,
                schArrTime: '11:22:25',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A8',
                stopSequence: 3,
                schArrTime: '11:25:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A9',
                stopSequence: 4,
                schArrTime: '11:28:43',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A10',
                stopSequence: 5,
                schArrTime: '11:30:56',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
            ],
            direction: '2',
          },
          {
            blockId: 'A80001',
            vehicleId: 'AV01',
            tripId: 'T8200004',
            stops: [
              {
                stopId: 'A6',
                stopSequence: 1,
                schArrTime: '13:20:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A7',
                stopSequence: 2,
                schArrTime: '13:22:25',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A8',
                stopSequence: 3,
                schArrTime: '13:25:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A9',
                stopSequence: 4,
                schArrTime: '13:28:43',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A10',
                stopSequence: 5,
                schArrTime: '13:30:56',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
            ],
            direction: '2',
          },
          {
            blockId: 'A80001',
            vehicleId: 'AV01',
            tripId: 'T8200005',
            stops: [
              {
                stopId: 'A6',
                stopSequence: 1,
                schArrTime: '14:20:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A7',
                stopSequence: 2,
                schArrTime: '14:22:25',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A8',
                stopSequence: 3,
                schArrTime: '14:25:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A9',
                stopSequence: 4,
                schArrTime: '14:28:43',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A10',
                stopSequence: 5,
                schArrTime: '14:30:56',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
            ],
            direction: '2',
          },
          {
            blockId: 'A80001',
            vehicleId: 'AV01',
            tripId: 'T8200006',
            stops: [
              {
                stopId: 'A6',
                stopSequence: 1,
                schArrTime: '15:20:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A7',
                stopSequence: 2,
                schArrTime: '15:22:25',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A8',
                stopSequence: 3,
                schArrTime: '15:25:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A9',
                stopSequence: 4,
                schArrTime: '15:28:43',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A10',
                stopSequence: 5,
                schArrTime: '15:30:56',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
            ],
            direction: '2',
          },
          {
            blockId: 'A80001',
            vehicleId: 'AV01',
            tripId: 'T8200007',
            stops: [
              {
                stopId: 'A6',
                stopSequence: 1,
                schArrTime: '16:20:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A7',
                stopSequence: 2,
                schArrTime: '16:22:25',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A8',
                stopSequence: 3,
                schArrTime: '16:25:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A9',
                stopSequence: 4,
                schArrTime: '16:28:43',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A10',
                stopSequence: 5,
                schArrTime: '16:30:56',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
            ],
            direction: '2',
          },
          {
            blockId: 'A80001',
            vehicleId: 'AV01',
            tripId: 'T8200008',
            stops: [
              {
                stopId: 'A6',
                stopSequence: 1,
                schArrTime: '17:20:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A7',
                stopSequence: 2,
                schArrTime: '17:22:25',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A8',
                stopSequence: 3,
                schArrTime: '17:25:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A9',
                stopSequence: 4,
                schArrTime: '17:28:43',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'A10',
                stopSequence: 5,
                schArrTime: '17:30:56',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
            ],
            direction: '2',
          },
        ],
      },
    ],
  },
  {
    routeId: '11',
    numBus: 1,
    stopList: [
      {
        direction: '1',
        stops: ['B1', 'B2', 'B3', 'B4', 'B5'],
      },
      {
        direction: '2',
        stops: ['B6', 'B7', 'B8', 'B9', 'B10'],
      },
    ],
    timetable: [
      {
        direction: '1',
        trips: [
          {
            blockId: 'B11002',
            vehicleId: 'AV02',
            tripId: 'T11100001',
            stops: [
              {
                stopId: 'B1',
                stopSequence: 1,
                schArrTime: '09:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'B2',
                stopSequence: 2,
                schArrTime: '09:05:02',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'B3',
                stopSequence: 3,
                schArrTime: '09:13:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'B4',
                stopSequence: 4,
                schArrTime: '09:24:08',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'B5',
                stopSequence: 5,
                schArrTime: '09:38:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
            ],
            direction: '1',
          },
          {
            blockId: 'B11002',
            vehicleId: 'AV02',
            tripId: 'T11100002',
            stops: [
              {
                stopId: 'B1',
                stopSequence: 1,
                schArrTime: '11:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'B2',
                stopSequence: 2,
                schArrTime: '11:05:02',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'B3',
                stopSequence: 3,
                schArrTime: '11:13:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'B4',
                stopSequence: 4,
                schArrTime: '11:24:08',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'B5',
                stopSequence: 5,
                schArrTime: '11:38:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
            ],
            direction: '1',
          },
          {
            blockId: 'B11002',
            vehicleId: 'AV02',
            tripId: 'T11100003',
            stops: [
              {
                stopId: 'B1',
                stopSequence: 1,
                schArrTime: '14:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'B2',
                stopSequence: 2,
                schArrTime: '14:05:02',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'B3',
                stopSequence: 3,
                schArrTime: '14:13:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'B4',
                stopSequence: 4,
                schArrTime: '14:24:08',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'B5',
                stopSequence: 5,
                schArrTime: '14:38:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
            ],
            direction: '1',
          },
          {
            blockId: 'B11002',
            vehicleId: 'AV02',
            tripId: 'T11100004',
            stops: [
              {
                stopId: 'B1',
                stopSequence: 1,
                schArrTime: '16:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'B2',
                stopSequence: 2,
                schArrTime: '16:05:02',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'B3',
                stopSequence: 3,
                schArrTime: '16:13:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'B4',
                stopSequence: 4,
                schArrTime: '16:24:08',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
              {
                stopId: 'B5',
                stopSequence: 5,
                schArrTime: '16:38:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '1',
                itp: 0,
              },
            ],
            direction: '1',
          },
        ],
      },
      {
        direction: '2',
        trips: [
          {
            blockId: 'B11002',
            vehicleId: 'AV02',
            tripId: 'T11200001',
            stops: [
              {
                stopId: 'B6',
                stopSequence: 1,
                schArrTime: '10:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'B7',
                stopSequence: 2,
                schArrTime: '10:14:50',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'B8',
                stopSequence: 3,
                schArrTime: '10:25:10',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'B9',
                stopSequence: 4,
                schArrTime: '10:35:04',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'B10',
                stopSequence: 5,
                schArrTime: '10:40:29',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
            ],
            direction: '2',
          },
          {
            blockId: 'B11002',
            vehicleId: 'AV02',
            tripId: 'T11200002',
            stops: [
              {
                stopId: 'B6',
                stopSequence: 1,
                schArrTime: '12:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'B7',
                stopSequence: 2,
                schArrTime: '12:14:50',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'B8',
                stopSequence: 3,
                schArrTime: '12:25:10',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'B9',
                stopSequence: 4,
                schArrTime: '12:35:04',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'B10',
                stopSequence: 5,
                schArrTime: '12:40:29',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
            ],
            direction: '2',
          },
          {
            blockId: 'B11002',
            vehicleId: 'AV02',
            tripId: 'T11200003',
            stops: [
              {
                stopId: 'B6',
                stopSequence: 1,
                schArrTime: '15:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'B7',
                stopSequence: 2,
                schArrTime: '15:14:50',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'B8',
                stopSequence: 3,
                schArrTime: '15:25:10',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'B9',
                stopSequence: 4,
                schArrTime: '15:35:04',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'B10',
                stopSequence: 5,
                schArrTime: '15:40:29',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
            ],
            direction: '2',
          },
          {
            blockId: 'B11002',
            vehicleId: 'AV02',
            tripId: 'T11200004',
            stops: [
              {
                stopId: 'B6',
                stopSequence: 1,
                schArrTime: '17:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'B7',
                stopSequence: 2,
                schArrTime: '17:14:50',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'B8',
                stopSequence: 3,
                schArrTime: '17:25:10',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'B9',
                stopSequence: 4,
                schArrTime: '17:35:04',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
              {
                stopId: 'B10',
                stopSequence: 5,
                schArrTime: '17:40:29',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                direction: '2',
                itp: 0,
              },
            ],
            direction: '2',
          },
        ],
      },
    ],
  },
];
